import { render, staticRenderFns } from "./flagged-costs-form-exclusions.vue?vue&type=template&id=459254df"
import script from "./flagged-costs-form-exclusions.vue?vue&type=script&lang=ts"
export * from "./flagged-costs-form-exclusions.vue?vue&type=script&lang=ts"
import style0 from "./flagged-costs-form-exclusions.vue?vue&type=style&index=0&id=459254df&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459254df')) {
      api.createRecord('459254df', component.options)
    } else {
      api.reload('459254df', component.options)
    }
    module.hot.accept("./flagged-costs-form-exclusions.vue?vue&type=template&id=459254df", function () {
      api.rerender('459254df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cost-exclusion-step/flagged-costs-lightbox/flagged-costs-form/flagged-costs-form-exclusions.vue"
export default component.exports